import { render } from "./MailingBlockTextEditor.vue?vue&type=template&id=3de8b5b2"
import script from "./MailingBlockTextEditor.vue?vue&type=script&lang=js"
export * from "./MailingBlockTextEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__